The identifier for the `HiringOrganization` to retrieve position openings for.
